export const mobile = `@media (max-width: 767px) `;
